'use strict';

angular.module('impactx.budget').controller('BudgetTemplateDialogCtrl', BudgetTemplateDialogCtrl);

BudgetTemplateDialogCtrl.$inject = ['$scope', 'dataGen', '$mdToast', 'templateId', '$mdDialog'];

function BudgetTemplateDialogCtrl($scope, dataGen, $mdToast, templateId, $mdDialog)
{
    $scope.closeDialog = function(answer) {
        $mdDialog.hide(answer);
    };

    this.save = function()
    {
        var dataObj = {
            template: $scope.data
        };
        dataGen.postAsForm($scope, dataObj, "/budgetTemplate/save").then(function (res)
        {
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
            $scope.closeDialog(res.data);
        });
    };

    dataGen.getData($scope, {id: templateId}, "/budgetTemplate/view");
}
